import React from "react";
import useShopStore from "../store/useShopStore";
import { useEffect } from "react";
import ProductCard from "../components/ProductCard";
import classes from "./Beer.module.css";
import PageHeading from "../utils/PageHeading";
import Spinner from "../utils/Spinner";
import GridCardContainer from "../utils/GridCardContainer";
export default function Beer() {
  const { getByCategory, beer } = useShopStore((state) => state);
  const urlparams = document.URL.split("#/").at(1);

  useEffect(() => {
    getByCategory(urlparams);
  }, [getByCategory, urlparams]);

  return (
    <div>
      <PageHeading>Beer</PageHeading>
      {!beer && <Spinner />}
      <GridCardContainer className={classes.cardContainer}>
        {beer &&
          beer.map((product) => {
            return (
              <ProductCard
                image={product.image}
                title={product.name}
                category={product.category}
                price={product.price}
                key={product._id}
                id={product._id}
              />
            );
          })}
      </GridCardContainer>
    </div>
  );
}
